import { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  authButton,
  bodyContainer,
  container,
  divider,
  input,
  itemText,
  modalButton,
  modalContainer,
  modalText,
  subContainer,
  titleText,
} from "./styles";
import { colors } from "../../theme/colors";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../services/firebase";
import { getErrorMessage, showToast } from "../../services/toast";

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate("/login");
  };

  const onPressOk = () => {
    setOpen(false);
    navigate("/login");
  };

  const handleForgotPassword = () => {
    setIsLoading(true);
    sendPasswordResetEmail(auth, email)
      .then((user) => {
        setOpen(true);
        setIsLoading(false);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = getErrorMessage(errorCode);
        showToast(errorMessage, "error");
        setIsLoading(false);
      });
  };

  return (
    <Box sx={(theme) => container(theme)}>
      <Box sx={(theme) => bodyContainer(theme)}>
        <Box sx={(theme) => subContainer(theme)}>
          <Typography sx={(theme) => titleText(theme)}>
            Forgot Password
          </Typography>
          <Divider sx={(theme) => divider(theme)}>continue with</Divider>
          <Typography sx={(theme) => itemText(theme)}>
            Entering your email address below
          </Typography>

          <TextField
            placeholder="Email address"
            size="small"
            fullWidth
            type="email"
            required
            sx={(theme) => input(theme)}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            sx={(theme) => authButton(theme)}
            disabled={isLoading}
            onClick={() => handleForgotPassword()}
          >
            Request Password Reset
          </Button>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "12px",
              color: colors.dark_gray,
              mb: 3,
              mt: 24,
            }}
          >
            By clicking continue, you agree to our{" "}
            <b style={{ color: "black" }}>Terms of Service</b> and{" "}
            <b style={{ color: "black" }}>Privacy Policy</b>
          </Typography>
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={(theme) => modalContainer(theme)}>
          <Typography sx={(theme) => modalText(theme)}>
            We sent the email to reset your password to your email address.
            Please check your inbox or junk email.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            sx={(theme) => modalButton(theme)}
            disabled={isLoading}
            onClick={() => onPressOk()}
          >
            Ok
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ForgotPassword;
